export const headerData = [
  {
    key: 'id',
    sortable: true,
    header: 'Id',
  },
  {
    key: 'name',
    sortable: true,
    header: 'Name',
  },
  {
    key: 'email',
    sortable: false,
    header: 'Email',
  },
  {
    key: 'createdAt',
    sortable: true,
    header: 'Created At',
  },
  {
    key: 'updatedAt',
    sortable: false,
    header: 'Updated At',
  },
];
